import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError } from 'rxjs';
import type { CreateLabelDTO, UpdateLabelDTO } from './models/LabelDTO';
import type { LabelEntity } from './models/LabelEntity';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  private readonly httpClient = inject(HttpClient);
  private readonly BASE = '/api/label/v2';
  /**
   *
   * @param payload
   * @returns
   */
  createLabel(payload: CreateLabelDTO) {
    return this.httpClient.post<LabelEntity>(`${this.BASE}/labels/management`, payload);
  }
  /**
   *
   * @param id
   * @returns
   */
  updateLabel(payload: UpdateLabelDTO) {
    return this.httpClient.put<LabelEntity>(`${this.BASE}/labels/management`, payload);
  }
  /**
   *
   * @param id
   * @returns
   */
  deleteLabel(id: string) {
    return this.httpClient.delete(`${this.BASE}/labels/management/${id}`);
  }
  /**
   *
   * @returns
   */
  getLabelById(id: string) {
    return this.httpClient.get<LabelEntity>(`${this.BASE}/labels/${id}`);
  }
  /**
   *
   * @param businessUnitId
   * @returns
   */
  getLabelByBusinessUnitId(businessUnitId: string) {
    return this.httpClient.get<LabelEntity[]>(`${this.BASE}/labels/businessUnits/${businessUnitId}`).pipe(
      catchError(() => {
        return [];
      })
    );
  }
}
